import { FormGroup, FormControl } from 'react-bootstrap';
import IPT from 'react-immutable-proptypes';
import s from './styles.scss';

export const NumberOnImageAnswer = ({ question }) => {
  const fields = question.get('fields').toJS();
  const imageUrl = question.get('image_url');
  const options = question.get('options').toJS();

  return (
    <form className={s.numberOnImage}>
      <div className={s.imageWrapper}>
        <FormGroup className={s.formGroup}>
          {fields?.map((field) => {
            const { id, width, height, x_position, y_position } = field;

            const correctOption = options.find((o) =>
              field.correct_options.includes(o.id)
            );
            const correctValue = correctOption?.value;

            return (
              <FormControl
                key={id}
                componentClass="textarea"
                value={correctValue}
                style={{
                  left: `${x_position}%`,
                  top: `${y_position}%`,
                  height: `${height}%`,
                  width: `${width}%`,
                }}
                disabled
              />
            );
          })}
        </FormGroup>
        <img src={imageUrl} />

        {/* 
        TODO: re-enable correctness ui when we can calulate it correctly
        <span className={s.check} />
        */}
      </div>
    </form>
  );
};

NumberOnImageAnswer.propTypes = {
  question: IPT.map.isRequired,
};
